export default "__VITE_ASSET__2d5db26c__"